export enum EventRequestDecisionKey {
  cannotRequest = 'cannotRequest',
  autoApprove = 'autoApprove',
  alreadyRequested = 'alreadyRequested',
  needsApproval = 'needsApproval',
}
